import { Table } from "antd";
import { Eye, Calendar, CheckSquare, Trash2 } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { handleConfirmBooking, handleFetchBookings } from "../../apis/bookings";
import Something from "../../components/Something";
import Moment from "react-moment";
import { AuthContext } from "../../contexts/AuthContext";
import PendingWidget from "./components/PendingWidget";
import ConfirmBooking from "./components/ConfirmBooking";
import BookingDetails from "./components/BookingDetails";
import FulfillBooking from "./components/FulfillBooking";
import DeleteBooking from "./components/DeleteBooking";
import ConfirmedWidget from "./components/ConfirmedWidget";
import FulfilledWidget from "./components/FulfilledWidget";
import AllWidget from "./components/AllWidget";
import RescheduleBooking from "./components/RescheduleBooking";
import { ColumnsType } from "antd/es/table";

export default function Bookings() {
  const { site } = useContext(AuthContext);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [detailsModal, setDetailsModal] = useState<boolean>(false);
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [reschedulePanel, setReschedulePanel] = useState<boolean>(false);
  const [fulfillModal, setFulfillModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: bookings,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["bookings", site?._id, pagination.page, pagination.limit],
    queryFn: () =>
      handleFetchBookings({
        site: site?._id === 0 ? "" : site?._id,
        page: pagination.page,
        limit: pagination.limit,
      }),
  });

  interface DataType {
    key: React.Key;
    name: string;
  }
  const columns: ColumnsType<DataType> = [
    {
      title: "S/N",
      width: 70,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
          {pagination?.page * pagination?.limit - pagination?.limit + index + 1}
        </span>
      ),
    },
    {
      title: "SITE",
      width: 150,
      render: (record: any) => (
        <div className="text-gray-700 truncate">{record?.site?.name}</div>
      ),
    },
    {
      title: "CUSTOMER",
      width: 240,
      render: (record: any) => (
        <div className="text-gray-700 truncate">{record?.name}</div>
      ),
    },
    // {
    //   title: "DRIVER",
    //   width: 240,
    //   render: (record: any) => (
    //     <div className="text-gray-700 truncate">{record?.driver || <span className="text-red-700">None</span>}</div>
    //   ),
    // },
    {
      title: "REQUESTED",
      width: 240,
      render: (record: any) => (
        <span className="text-gray-700">
          <Moment fromNow>{record?.createdAt}</Moment>
        </span>
      ),
    },
    {
      title: "VEHICLE",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">{record?.registration}</div>
      ),
    },
    {
      title: "MAKE",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">{record?.vehicleMake}</div>
      ),
    },
    {
      title: "MODEL",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">{record?.vehicleModel}</div>
      ),
    },
    {
      title: "MILEAGE",
      width: 140,
      render: (record: any) => (
        <span className="text-gray-700">{record?.mileage} Kms</span>
      ),
    },
    {
      title: "DATE",
      width: 220,
      render: (record: any) => (
        <span className="text-gray-700">
          <Moment format="DD-MM-YYYY">{record?.date}</Moment>
        </span>
      ),
    },
    {
      title: "TIME",
      width: 120,
      render: (record: any) => (
        <span className="text-gray-700">
          <Moment format="HH:mm">{record?.startTime}</Moment>
          <span className="mx-2">-</span>
          <Moment format="HH:mm">{record?.endTime}</Moment>
        </span>
      ),
    },
    {
      title: "BOOKING NO",
      width: 160,
      render: (record: any) => (
        <span className="text-gray-700">{record?.bookingNo}</span>
      ),
    },
    {
      title: "WIP",
      width: 80,
      render: (record: any) => (
        <div className="">
          {record?.wip ? (
            <div className="text-center">{record?.wip}</div>
          ) : (
            <button
              onClick={() => {
                setSelected(record);
                setFulfillModal(true);
              }}
              className="flex items-center border bg-gray-50 rounded-sm px-2  text-red-600"
            >
              <span className="mx-1">+WIP</span>
            </button>
          )}
        </div>
      ),
    },
    {
      title: "ASSIGNED TO",
      width: 250,
      render: (record: any) => (
        <div className="text-gray-700 truncate">{record?.user?.name || <span className="text-red-700">None</span>}</div>
      ),
    },
    {
      title: "RESCHEDULE",
      width: 170,
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected(record);
              setReschedulePanel(true);
            }}
            className="flex items-center bg-yellow-50 border rounded-sm px-2  text-gray-700 mr-1"
          >
            <Calendar size={16} /> <span className="mx-1">Reschedule</span>
          </button>
          {record?.isConfirmed ? (
            <button
              onClick={() => {
                setSelected(record);
                setDeleteModal(true);
              }}
              className="flex items-center bg-red-50 border rounded-sm px-2  text-red-700"
            >
              <Trash2 size={16} />
            </button>
          ) : (
            <button
              onClick={() => {
                setSelected(record);
                setDeleteModal(true);
              }}
              className="flex items-center bg-red-50 border rounded-sm px-2  text-red-700"
            >
              <Trash2 size={16} />
            </button>
          )}
        </div>
      ),
    },
    {
      title: "STATUS",
      width: 140,
      render: (record: any) => (
        <div className="">
          {record?.status === "Unconfirmed" ? (
            <button
              onClick={() => {
                setSelected(record);
                setConfirmModal(true);
              }}
              className="flex items-center bg-gray-100 rounded-sm px-2  text-red-700 border"
            >
              <span className="mx-1">Unconfirmed</span>
            </button>
          ) : (
            <button
              className="flex items-center bg-green-50 rounded-sm px-2  text-gray-700"
            >
              <CheckSquare size={16} /> <span className="ml-1">Confirmed</span>
            </button>
          )}
        </div>
      ),
    },
    {
      title: "DETAILS",
      width: 100,
      render: (record: any) => (
        <button
          onClick={() => {
            setSelected(record);
            setDetailsModal(true);
          }}
          className="flex items-center bg-blue-50 rounded-sm px-2  border text-gray-700"
        >
          <Eye size={16} /> <span className="mx-1">Details</span>
        </button>
      ),
    },
  ];

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  useEffect(() => {
    setPagination({ ...pagination, total: bookings?.total });
  }, [bookings]);

  return (
    <div className="bg-gray-100">
      <div className="bg-white">
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="p-2">
            <div className="grid gap-2 grid-cols-12 mb-4">
              <PendingWidget />
              <ConfirmedWidget />
              <FulfilledWidget />
              <AllWidget />
            </div>
            <div className="flex flex-col shadow-sm">
              <div className="flex flex-col w-full ">
                <div className="grid gap-x-0 grid-cols-12">
                  <div className="col-span-12 sm:col-span-12 md:col-span-12">
                    <Table
                      columns={columns}
                      dataSource={bookings?.records}
                      size="small"
                      bordered
                      scroll={{ y: 560, x: 0 }}
                      loading={isLoading}
                      pagination={{
                        current: pagination?.page,
                        pageSize: pagination?.limit,
                        total: pagination?.total,
                      }}
                      onChange={(e: any) => handlePageChange(e)}
                      rowKey="_id"
                    />
                  </div>
                </div>
              </div>

              {confirmModal && (


                <ConfirmBooking
                  isVisible={confirmModal}
                  setVisible={setConfirmModal}
                  selected={selected}
                />
              )}

              {deleteModal && (
                <DeleteBooking
                  isVisible={deleteModal}
                  setVisible={setDeleteModal}
                  selected={selected}
                />
              )}

              {reschedulePanel && (
                <RescheduleBooking
                  isVisible={reschedulePanel}
                  setVisible={setReschedulePanel}
                  selected={selected}
                />
              )}

              {fulfillModal && (
                <FulfillBooking
                  isVisible={fulfillModal}
                  setVisible={setFulfillModal}
                  selected={selected}
                />

              )}

              {detailsModal && (
                <BookingDetails
                  isVisible={detailsModal}
                  setVisible={setDetailsModal}
                  selected={selected}
                  handleConfirmBooking={handleConfirmBooking}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
